export default __webpack_public_path__ + "static/media/bnb.ea95d09f.svg";